// Helpers ImageKit.io pour LunaNuva / Onyros
// - getOptimizedImageUrl: génère une URL avec transformations (tr:...)

const urlEndpoint = 'https://ik.imagekit.io/0oqxpt30u';

export type TransformFormat = 'webp' | 'jpg' | 'png';

export interface TransformOptions {
  width?: number;
  height?: number;
  quality?: number; // 1..100
  format?: TransformFormat;
  crop?: 'maintain_ratio' | 'force';
}

// Accepte un chemin ("/lunanuva/tests/img.png") ou une URL complète ImageKit
export function getOptimizedImageUrl(pathOrUrl: string, t?: TransformOptions): string {
  if (!pathOrUrl) return '';

  // Extraire le path propre (sans tr: si déjà présent)
  let cleanPath = pathOrUrl;
  try {
    if (pathOrUrl.startsWith('http')) {
      const u = new URL(pathOrUrl);
      const parts = u.pathname.split('/').filter(Boolean);
      // parts[0] est l'id projet (0oqxpt30u)
      const withoutProject = parts.slice(1);
      const trIndex = withoutProject.findIndex(p => p.startsWith('tr:'));
      const fileParts = trIndex === -1 ? withoutProject : withoutProject.slice(trIndex + 1);
      cleanPath = '/' + fileParts.join('/');
    }
  } catch {
    // pas une URL, on suppose que c'est déjà un path
  }

  if (!cleanPath.startsWith('/')) cleanPath = '/' + cleanPath;

  const params: string[] = [];
  if (t?.width) params.push(`w-${t.width}`);
  if (t?.height) params.push(`h-${t.height}`);
  if (t?.quality) params.push(`q-${t.quality}`);
  if (t?.format) params.push(`f-${t.format}`);
  if (t?.crop) params.push(`c-${t.crop}`);

  return params.length > 0
    ? `${urlEndpoint}/tr:${params.join(',')}${cleanPath}`
    : `${urlEndpoint}${cleanPath}`;
}
